<template>
  <div class="layout">
    <div class="layout_nav">
      <Nav v-bind="getRol"></Nav>
    </div>
    <div class="layout_center">
      <v-container fluid>
        <v-row>
          <v-col class="pa-0">
            <Welcome v-bind="getUser"></Welcome>
          </v-col>
          <v-col class="pa-0 py-5" md="auto">
            <Snackbar
              v-bind:visible="getAlert.snackbar"
              v-bind:text="getAlert.text"
            ></Snackbar>
            <div class="ctn_indicator">
              <!-- indicador -->
              <Indicator
                v-bind:active="getListStation.active"
                v-bind:inactive="getListStation.inactive"
              ></Indicator>
              <!-- btn crear  -->
              <div v-if="isMaster == 1" class="ctn_btn_new">
                <v-btn
                  class="btn_new"
                  @click.stop="newFlag = true"
                  color="primary"
                >
                  <v-icon>mdi-plus-circle-outline</v-icon>
                  <span>
                    Crear Estación
                  </span>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <!-- tabla de datos -->
      <TableStationComp></TableStationComp>
      <New :visible="newFlag" @close="newFlag = false"></New>
    </div>
  </div>
</template>
<script>
import Nav from '@/components/Nav.vue'
import Welcome from '@/components/Welcome.vue'
import Indicator from '@/components/Indicator.vue'
import Snackbar from '@/components/Snackbar.vue'
import New from '@/components/station/New.vue'
import TableStationComp from '@/components/station/Table.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'StationHome',
  components: {
    Nav,
    Welcome,
    Indicator,
    Snackbar,
    TableStationComp,
    New,
  },
  data() {
    return {
      newFlag: false,
    }
  },
  async mounted() {
    // mounted
    this.listStation()
  },
  methods: {
    ...mapActions(['listStation']),
  },
  computed: {
    ...mapGetters([
      'getListStation',
      'getUser',
      'getAlert',
      'getRol',
      'isMaster',
    ]),
    // stationActive() {
    //   let active = this.getListStation
    //     .map((item) => {
    //       if (item.activate == 1) {
    //         return item;
    //       }
    //     })
    //     .filter((item) => {
    //       return item;
    //     });
    //   return active.length;
    // },
    // stationInactive() {
    //   let active = this.getListStation
    //     .map((item) => {
    //       if (item.activate == 0) {
    //         return item;
    //       }
    //     })
    //     .filter((item) => {
    //       return item;
    //     });
    //   return active.length;
    // }
  },
}
</script>
<style></style>
